module.exports = __webpack_public_path__ + "static/media/russellELevine.af308ab5.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/russellELevine.jpg
// module id = 1693
// module chunks = 1